import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    width: '100%',
    marginBottom: '1rem',
    flexWrap: 'nowrap',
    borderRadius: 6,
  },
  infoIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  text: {
    color: theme.palette.black.main,
    fontSize: '0.9rem',
    padding: '5px 10px 5px 0px',
    textAlign: 'justify',
  },
}));

export default useStyles;
